interface Props {
  size?: number;
  color?: string;
}

const UsersIcon = (props: Props) => {
  const { color = '#000', size = 25 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox={`0 0 24 24`}
    >
      <g clipPath="url(#clip0_1677_3019)">
        <path
          d="M3.3999 21.6699V19.6699C3.3999 18.6091 3.82133 17.5916 4.57148 16.8415C5.32162 16.0914 6.33904 15.6699 7.3999 15.6699H11.3999C12.4608 15.6699 13.4782 16.0914 14.2283 16.8415C14.9785 17.5916 15.3999 18.6091 15.3999 19.6699V21.6699M16.3999 3.79992C17.2603 4.02022 18.0229 4.52062 18.5675 5.22223C19.1121 5.92384 19.4077 6.78675 19.4077 7.67492C19.4077 8.56309 19.1121 9.426 18.5675 10.1276C18.0229 10.8292 17.2603 11.3296 16.3999 11.5499M21.3999 21.6699V19.6699C21.3948 18.7871 21.0978 17.9307 20.5552 17.2343C20.0125 16.5379 19.2547 16.0406 18.3999 15.8199M5.3999 7.66992C5.3999 8.73079 5.82133 9.7482 6.57148 10.4983C7.32162 11.2485 8.33904 11.6699 9.3999 11.6699C10.4608 11.6699 11.4782 11.2485 12.2283 10.4983C12.9785 9.7482 13.3999 8.73079 13.3999 7.66992C13.3999 6.60906 12.9785 5.59164 12.2283 4.84149C11.4782 4.09135 10.4608 3.66992 9.3999 3.66992C8.33904 3.66992 7.32162 4.09135 6.57148 4.84149C5.82133 5.59164 5.3999 6.60906 5.3999 7.66992Z"
          stroke={color}
          strokeWidth={1.6}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1677_3019">
          <rect
            width={20}
            height={20}
            fill={color}
            transform="translate(0.399902 0.669922)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default UsersIcon;
